import { render } from "./daily.vue?vue&type=template&id=312028f0&ts=true"
import script from "./daily.vue?vue&type=script&lang=ts"
export * from "./daily.vue?vue&type=script&lang=ts"

import exportComponent from "/home/asan/haisha/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__